import React from "react";
import { Breadcrumb, Tab, Tabs } from "react-bootstrap";
import useReactRouter from "use-react-router";

import { hasPermission } from "../../../constants/permissions";
import SettingsStaff from "./SettingsStaff";
import SettingsRole from "./SettingsRole";

const TABS = [
  { key: "staff", title: "ພະນັກງານ", permission: "STAFF_MANAGEMENT", Component: SettingsStaff },
  { key: "role", title: "ບົດບາດ ແລະ ສິດ", permission: "STAFF_MANAGEMENT", Component: SettingsRole },
];

export default function SettingsStaffRole() {
  const { history, location } = useReactRouter();
  const tabs = TABS.filter((t) => hasPermission(t.permission));
  const requested = new URLSearchParams(location.search).get("tab");
  const activeKey = tabs.some((t) => t.key === requested) ? requested : tabs[0]?.key;

  return (
    <div style={{ marginTop: "2.5em", padding: "1em .55em" }}>
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => history.replace("/settings")}>ຕັ້ງຄ່າ</Breadcrumb.Item>
        <Breadcrumb.Item active>ຈັດການພະນັກງານ ແລະ ສິດ</Breadcrumb.Item>
      </Breadcrumb>

      {/* unmountOnExit: each tab refetches when opened, so a role made in one tab
          is already in the other tab's dropdown. */}
      <Tabs
        activeKey={activeKey}
        onSelect={(key) => history.replace(`/settings-staff?tab=${key}`)}
        mountOnEnter
        unmountOnExit
        className="mb-3"
      >
        {tabs.map(({ key, title, Component }) => (
          <Tab key={key} eventKey={key} title={title}>
            <Component />
          </Tab>
        ))}
      </Tabs>
    </div>
  );
}
